import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

const LEGAL_LINKS = [
  { to: "/terms", label: "Terms of Service" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/service-agreement", label: "Service Agreement" },
  { to: "/refund-policy", label: "Refund Policy" },
];

export const LegalLayout = ({ title, updated, children, current }) => (
  <div className="min-h-screen bg-zinc-50 text-zinc-900">
    <header className="border-b border-zinc-200 bg-white" data-testid="legal-header">
      <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-logo-link">
          <div className="w-7 h-7 bg-zinc-900 rounded-md flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-black text-lg">NextGen<span className="text-blue-600"> Resolution Experts</span></span>
        </Link>
        <Link to="/" className="text-sm font-medium text-zinc-500 hover:text-zinc-900 flex items-center gap-1.5" data-testid="legal-back-home">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </header>

    <main className="max-w-4xl mx-auto px-6 py-14" data-testid="legal-content">
      <h1 className="font-display font-black text-4xl sm:text-5xl mb-2">{title}</h1>
      <p className="text-sm text-zinc-500 mb-10">Last updated: {updated}</p>
      <div className="legal-prose space-y-8 text-zinc-700 leading-relaxed text-[15px]">{children}</div>

      <div className="mt-16 pt-8 border-t border-zinc-200">
        <p className="text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-3">Other legal documents</p>
        <div className="flex flex-wrap gap-4 text-sm">
          {LEGAL_LINKS.filter((l) => l.to !== current).map((l) => (
            <Link key={l.to} to={l.to} className="text-blue-600 hover:underline font-medium" data-testid={`legal-nav-${l.to.slice(1)}`}>
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </main>

    <footer className="border-t border-zinc-200 py-8 px-6 bg-white text-center text-sm text-zinc-400">
      © 2026 NextGen Resolution Experts · Questions? Contact{" "}
      <a href="mailto:support@nextgenresolutionexperts.com" className="text-blue-600 hover:underline">support@nextgenresolutionexperts.com</a>
    </footer>
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-display font-bold text-lg md:text-lg text-zinc-900 mb-3">{heading}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);
